import apiAgent from './src/common/api_agent.js';

document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector(".form-select");
  const options = document.querySelectorAll(".form-select option");
  const couponCodeSpace = document.getElementById("coupon-code-space")
  select.addEventListener('change', function(){
    for(let state of options) {
      if(state.selected) {
        if(state.value.match(/plan/)){
          couponCodeSpace.style.display = "flex" // row class なのでblockではなくflexを使う
        }
        else{
          couponCodeSpace.style.display = "none"
        }
      }
    }
  })

  const checkCoupon = document.getElementById('check-coupon')
  const couponCode = document.getElementById("coupon-code-space")
  const couponMessage = document.getElementById("coupon-message")
  checkCoupon.addEventListener('click', async() => {
    const code = couponCode.value
    const response = await apiAgent({ url: `/inquiries/coupon?code=${code}`, method: 'GET'})
    if(response.status===404){
      const message = `クーポンが存在しません`
      couponMessage.innerHTML = message
      return
    }
    const json = await response.json()
    const message = `${json.name} ${json.discount}円OFF<br>契約者様のお名前は紹介店に共有させていただきます。`
    couponMessage.innerHTML = message
  })
})
